import { render, staticRenderFns } from "./Carregando.vue?vue&type=template&id=d22c8628&"
import script from "./Carregando.vue?vue&type=script&lang=js&"
export * from "./Carregando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports